import { map, find } from 'lodash';

const inboxList = [
  {
    id: 1,
    subject: "Important information about your new account",
    preview: "Log in to see your recent activity",
    author: {
      email: "fake@mail.com",
      name: "Fidelity Investments"
    },
    time: "10:49 PM"
  },
  {
    id: 2,
    subject: "Start your policy today for $84.75",
    preview: "A great rate from a company you trust",
    author: {
      email: "fake@mail.com",
      name: "Geico"
    },
    time: "5:19 PM"
  },
  {
    id: 3,
    subject: "Save $5 whenever you are hungry",
    preview: "Stop by your local Panera to see what's fresh",
    author: {
      email: "fake@mail.com",
      name: "Panera"
    },
    time: "3:57 PM"
  },
  null,
  {
    id: 5,
    subject: "Weekend plans",
    preview: "Are we still going hiking this weekend?",
    author: {
      email: "fake@mail.com",
      name: "Jessica Smith"
    },
    time: "11:35 AM"
  },
  {
    id: 6,
    subject: "Andrew Smith sent a message to your group conversation",
    preview: "Personal Facebook notification",
    author: {
      email: "fake@mail.com",
      name: "Andrew Smith"
    },
    time: "9:35 AM"
  }
];

const testTargetEmails = [
  {
    id: 4,
    subject: "[TEST TARGET EMAIL - WRONG PARAMETERS] 'First Name', you're eligible for monthly discounts on your Verizon account.",
    preview: "Our appreciation for your loyalty.",
    author: {
      email: "verizon@mail.com",
      name: "[TEST] Verizon"
    },
    time: "2:22 PM",
    target: true,
    path: "example-1"
  }
];

const bauTargetEmails = [
  {
    id: 7,
    subject: "Internet down, <FirstName>? We’ve got your back.",
    preview: "Valued mobile customers deserve to stay connected with new Verizon Wi-Fi Backup.",
    author: {
      email: "verizon@mail.com",
      name: "Verizon"
    },
    time: "10:26 AM",
    target: true,
    path: "wifi-backup",
    type: "customer"
  },
  {
    id: 8,
    subject: "Internet down, <FirstName>? We’ve got your back.",
    preview: "Stay connected with new Verizon Wi-Fi Backup.",
    author: {
      email: "verizon@mail.com",
      name: "Verizon"
    },
    time: "10:36 AM",
    target: true,
    path: "wifi-backup",
    type: "prospect"
  }
];

const concept1TargetEmails = [
  {
    id: 9,
    subject: "Here’s your exclusive invite to earn 4.30% APY: introducing Verizon + Openbank Savings.",
    preview: "",
    author: {
      email: "no-reply@customer.verizon.com",
      name: "Verizon Wireless"
    },
    time: "1:57&nbsp;PM",
    target: true,
    path: "openbank",
    name: "<firstName>",
    receiver: "<userEmail>"
  }
];

const concept2TargetEmails = [
  {
    id: 10,
    subject: "Fios lets you have it all—it’s more than just home internet.",
    preview: "Get it for less when you bundle Verizon mobile and home",
    author: {
      email: "no-reply@customer.verizon.com",
      name: "Verizon Wireless"
    },
    time: "1:57&nbsp;PM",
    target: true,
    path: "verizon-tv1",
    telNumber: "888-275-1008",
    name: "<firstName>",
    receiver: "<userEmail>"
  },
  {
    id: 11,
    subject: "Fios lets you have it all—it’s more than just home internet.",
    preview: "Get it for less when you bundle Verizon mobile and home",
    author: {
      email: "no-reply@customer.verizon.com",
      name: "Verizon Wireless"
    },
    time: "1:57&nbsp;PM",
    target: true,
    path: "verizon-tv2",
    telNumber: "888-275-1008",
    name: "<firstName>",
    receiver: "<userEmail>"
  },
  {
    id: 12,
    subject: "Fios lets you have it all—it’s more than just home internet.",
    preview: "Get it for less when you bundle Verizon mobile and home",
    author: {
      email: "no-reply@customer.verizon.com",
      name: "Verizon Wireless"
    },
    time: "1:57&nbsp;PM",
    target: true,
    path: "verizon-tv3",
    telNumber: "888-275-1008",
    name: "<firstName>",
    receiver: "<userEmail>"
  }
];


// BUZZ-3479: VerizonProgress, cells 1-4 (Day 1 Onboarding cells 1-3 + Gratitude cell 4)
const verizonProgressAuthor = {
  email: "no-reply@customer.verizon.com",
  name: "Verizon"
};

const verizonProgressOnboardingEmail = (id, variant) => ({
  id,
  subject: "Now let’s help you get more from Verizon",
  preview: "Unlock discounts, monthly savings and protection.",
  author: verizonProgressAuthor,
  time: "1:57&nbsp;PM",
  target: true,
  path: "verizon-progress-onboarding",
  name: "<FirstName>",
  receiver: "username@domain.com",
  variant
});

const verizonProgressTargetEmails = [
  // Cell 1: no top banner, no "Thanks" block
  verizonProgressOnboardingEmail(13, { topBanner: false, thanksBlock: false }),
  // Cell 2: no top banner, with "Thanks" block
  verizonProgressOnboardingEmail(14, { topBanner: false, thanksBlock: true }),
  // Cell 3: top banner + "Thanks" block
  verizonProgressOnboardingEmail(15, { topBanner: true, thanksBlock: true }),
  // Cell 4: Gratitude email with heart
  {
    id: 16,
    subject: "Big thanks, <FirstName>",
    preview: "We’re glad you chose us for your mobile service.",
    author: verizonProgressAuthor,
    time: "1:57&nbsp;PM",
    target: true,
    path: "verizon-progress-gratitude",
    name: "<FirstName>",
    receiver: "username@domain.com"
  }
];

const inboxWithTarget = (targetEmail) => map(inboxList, (el) => (el?.id ? el : targetEmail));

const data = {
  default: {
    inboxList: map(
      inboxList, (el) => (el?.id ? el : testTargetEmails[0])
    )
  },
  bau: {
    multiRespondentKind: true,
    customer: {
      inboxList: map(
        inboxList, (el) => (
          el?.id ?
            el :
            find(bauTargetEmails, (item) => item.type === "customer")
        )
      )
    },
    prospect: {
      inboxList: map(
        inboxList, (el) => (
          el?.id ?
            el :
            find(bauTargetEmails, (item) => item.type === "prospect")
        )
      )
    }
  },
  concept1: {
    inboxList: map(
      inboxList, (el) => (el?.id ? el : concept1TargetEmails[0])
    )
  },
  concept2a: {
    inboxList: map(
      inboxList, (el) => (el?.id ? el : concept2TargetEmails[0])
    )
  },
  concept2b: {
    inboxList: map(
      inboxList, (el) => (el?.id ? el : concept2TargetEmails[1])
    )
  },
  concept2c: {
    inboxList: map(
      inboxList, (el) => (el?.id ? el : concept2TargetEmails[2])
    )
  },
  // concept_name is downcased by the controller: "VerizonProgress" -> "verizonprogress";
  // the target email is chosen by the `cell` param (1-4)
  verizonprogress: {
    multiCell: true,
    cells: {
      1: { inboxList: inboxWithTarget(verizonProgressTargetEmails[0]) },
      2: { inboxList: inboxWithTarget(verizonProgressTargetEmails[1]) },
      3: { inboxList: inboxWithTarget(verizonProgressTargetEmails[2]) },
      4: { inboxList: inboxWithTarget(verizonProgressTargetEmails[3]) }
    }
  }
};


const findInputBox = (conceptName, respondentKind, cell) => {
  const defaultInboxList = data.default.inboxList;
  let resultHash = data[conceptName];

  if (!resultHash) {
    return defaultInboxList;
  }

  if (resultHash.multiCell) {
    resultHash = resultHash.cells[cell];
    if (!resultHash) {
      return defaultInboxList;
    }
  }

  if (resultHash.multiRespondentKind) {
    resultHash = resultHash[respondentKind];
    if (!resultHash) {
      return defaultInboxList;
    }
  }

  return resultHash.inboxList;
};

export default findInputBox;
